import { LitElement, html } from "lit-element";
import WebMidi from "webmidi";
import { scale, getRandomInRange, getRandomRGBColor } from "./utils";

import "./rhythmic-color";
import "./midi-in";

class DoritosWrapper extends LitElement {
    static get properties() {
        return {};
    }

    constructor() {
        super();

        this.darkOrange = "rgb(251, 11, 16)";
        this.lightOrange = "rgb(251, 113, 4)";
        this.mustard = "rgb(240, 190, 50)";
        this.magenta = "rgb(255, 14, 93)";
        this.darkBlue = "rgb(25, 37, 110)";
        this.mediumBlue = "rgb(28,60,140)";
        this.lightBlue = "rgb(20, 167, 217)";
        this.accentBlue = "rgb(67, 255, 231)";
        this.black = "rgb(0,0,0)";
        this.white = "rgb(255,255,255)";

        this.lime = "rgb(150,255,51)";
        this.flaminHot = "rgb(233,37,56)";
        this.flaminHotDark = "rgb(200,40,40)";
        this.yellow = "rgb(235,245,55)";

        /*********** original ***************/
        // this.baseColor = this.darkOrange;
        // this.gradientDark = this.darkOrange;
        // this.gradientLight = this.lightOrange;
        // this.boxShadow = this.lightOrange;

        // this.agogoHigh = this.white;
        // this.agogoLow = this.white;
        // this.synthLow = this.magenta;
        // this.synthHigh = this.accentBlue;
        // this.hihat = this.mustard;
        // this.claps = this.accentBlue;
        // this.snaps = this.white;
        // this.snare = this.mustard;
        // this.cycleColorValues = "[[251, 11, 16], [251, 113, 4], [255, 14, 93]]";

        /*********** cool ranch ***************/
        // this.baseColor = this.darkBlue;
        // this.gradientDark = this.darkBlue;
        // this.gradientLight = this.lightBlue;
        // this.boxShadow = this.lightBlue;

        // this.agogoHigh = this.white;
        // this.agogoLow = this.white;
        // this.synthLow = this.darkOrange;
        // this.synthHigh = this.mustard;
        // this.hihat = this.mustard;
        // this.claps = this.accentBlue;
        // this.snaps = this.white;
        // this.snare = this.mustard;
        // this.cycleColorValues =
        //     "[[25, 37, 110], [67, 255, 231], [251, 11, 16]]";

        /*********** flamin hot lime ***************/
        this.baseColor = this.flaminHot;
        this.gradientLight = this.lime;
        this.boxShadow = this.lime;

        this.agogoHigh = this.white;
        this.agogoLow = this.white;
        this.synthLow = this.flaminHotDark;
        this.synthHigh = this.lime;
        this.hihat = this.flaminHot;
        this.claps = this.yellow;
        this.snaps = this.white;
        this.snare = this.flaminHot;
        this.cycleColorValues = "[[233,37,56], [235,245,55], [139,230,51]]";

        /*********** flamin hot ***************/
        // this.baseColor = this.yellow;
        // this.boxShadow = this.flaminHotDark;

        // this.agogoHigh = this.white;
        // this.agogoLow = this.white;
        // this.synthLow = this.darkOrange;
        // this.synthHigh = this.mustard;
        // this.hihat = this.flaminHotDark;
        // this.claps = this.yellow;
        // this.snaps = this.white;
        // this.snare = this.yellow;
        // this.cycleColorValues = "[[200,40,40], [235,245,55], [233,37,56]]";
    }

    render() {
        return html`
            <style>
                :host {
                    margin: 0 auto;
                }
                #container {
                    position: absolute;
                    display: inline-block;
                    width: 100%;
                    height: 100%;
                    background: black;
                }

                #drums {
                    position: relative;
                    top: 8%;
                    height: 70%;
                }
            </style>
            <div id="container">
                <midi-in
                    source="IAC Driver Bus 4"
                    position="absolute"
                    fill="true"
                    cycleColor="true"
                    cycleColorValues=${this.cycleColorValues}
                    backgroundColor="transparent"
                ></midi-in>

                <div id="drums">
                    <midi-in
                        id="cowbell"
                        position="relative"
                        source="IAC Driver Bus 3"
                        highNote="50"
                        lowNote="48"
                        left="15%"
                        width="70%"
                        height="20%"
                        backgroundColor="${this.baseColor}"
                        boxShadow="0px 0px 50px 0px ${this.boxShadow}
                ,inset 0px 0px 100px 30px ${this.boxShadow}
                "
                        startColor="${this.agogoHigh}"
                        endColor="${this.agogoLow}"
                        borderRadius="100"
                    ></midi-in>

                    <rhythmic-color
                        id="snare"
                        orientation="custom"
                        position="relative"
                        source="IAC Driver Bus 10"
                        left="15%"
                        width="70%"
                        height="20%"
                        numNotes="5"
                        startFrom="left"
                        startFadeAfterMilliseconds="150"
                        transitionDuration="0s"
                        backgroundColor="${this.baseColor}"
                        boxShadow="0px 0px 50px 0px ${this.boxShadow}
                ,inset 0px 0px 100px 30px ${this.boxShadow}
                "
                        startColor="${this.snare}"
                        endColor="${this.snare}"
                        borderRadius="0px"
                        opacityCC="74"
                    ></rhythmic-color>

                    <rhythmic-color
                        id="hihat"
                        orientation="custom"
                        position="relative"
                        source="IAC Driver Bus 11"
                        left="15%"
                        width="70%"
                        height="20%"
                        numNotes="12"
                        startFrom="left"
                        startFadeAfterMilliseconds="150"
                        transitionDuration="0s"
                        backgroundColor="${this.baseColor}"
                        boxShadow="0px 0px 50px 0px ${this.boxShadow}
                ,inset 0px 0px 100px 30px ${this.boxShadow}
                "
                        startColor="${this.hihat}"
                        endColor="${this.hihat}"
                        borderRadius="0px"
                        opacityCC="74"
                    ></rhythmic-color>

                    <rhythmic-color
                        id="synth"
                        orientation="custom"
                        position="relative"
                        source="IAC Driver Bus 6"
                        left="15%"
                        width="70%"
                        height="20%"
                        numNotes="11"
                        startFrom="left"
                        startFadeAfterMilliseconds="150"
                        transitionDuration="1s"
                        backgroundColor="${this.baseColor}"
                        boxShadow="0px 0px 50px 0px ${this.boxShadow}
                ,inset 0px 0px 100px 30px ${this.boxShadow}
                "
                        startColor="${this.synthLow}"
                        endColor="${this.synthHigh}"
                        borderRadius="0px"
                        opacityCC="74"
                    ></rhythmic-color>

                    <rhythmic-color
                        id="claps"
                        position="relative"
                        source="IAC Driver Bus 12"
                        left="15%"
                        width="70%"
                        height="20%"
                        numNotes="1"
                        startFrom="left"
                        startFadeAfterMilliseconds="150"
                        transitionDuration="2s"
                        backgroundColor="${this.baseColor}"
                        boxShadow="0px 0px 50px 0px ${this.boxShadow}
                ,inset 0px 0px 100px 30px ${this.boxShadow}
                "
                        startColor="${this.claps}"
                        borderRadius="0px"
                        opacityCC="74"
                    ></rhythmic-color>

                    <rhythmic-color
                        id="snaps"
                        position="relative"
                        source="IAC Driver Bus 13"
                        left="15%"
                        width="70%"
                        height="20%"
                        numNotes="1"
                        startFrom="left"
                        startFadeAfterMilliseconds="20"
                        transitionDuration=".2s"
                        backgroundColor="${this.baseColor}"
                        boxShadow="0px 0px 50px 0px ${this.boxShadow}
                ,inset 0px 0px 100px 30px ${this.boxShadow}
                "
                        startColor="${this.snaps}"
                        borderRadius="0px"
                        opacityCC="74"
                    ></rhythmic-color>
                </div>
            </div>
        `;
    }
}

customElements.define("doritos-wrapper", DoritosWrapper);
